module.exports = __webpack_public_path__ + "static/media/Avatar_18.59663624.svg";